


















import {Component, Mixins} from 'vue-mixin-decorator';

import {BaseComponent} from '@/mixins/BaseComponent';
import SystemDiskUsageWidget from '@/components/System/Stats/SystemDiskUsageWidget.vue';
import SystemStorageUserData from '@/components/System/Storage/SystemStorageUserData.vue';

@Component({
  components: {SystemStorageUserData, SystemDiskUsageWidget},
})
export default class SystemStoragePage extends Mixins<BaseComponent>(BaseComponent) {

}
